import $ from 'jquery';
import Registry from "./Registry";

export default class Context {
	constructor(contextData) {
		this.contextData = contextData;
		this.loadComponents();
		this.defaultContext();
	}

	// Rendi la funzione ASYNC
	async loadComponents(context) {
		let registry = new Registry();
		let selector = '[data-g-component]';
		const elements = $(selector, context || document).get();

		//console.log(`Found ${elements.length} elements with [data-g-component]`);

		for (const elem of elements) {
			const $elem = $(elem);
			if (!$elem.data('g-component-initialized')) {
				const componentName = $elem.data('g-component');
				const componentInfo = registry.getComponent(componentName);

				if (componentInfo) {
					let Cmp = null;
					try {
						if (typeof componentInfo === 'function' && componentInfo.name === '') {
							const module = await componentInfo();
							Cmp = module.default;
							if (Cmp) {
								console.log(`Componente "${componentName}": Caricato dinamicamente.`);
							} else {
								console.warn(`Componente "${componentName}": L'import dinamico non ha restituito un export di default valido.`);
								continue; // Salta al prossimo elemento
							}
						} else if (typeof componentInfo === 'function') {
							Cmp = componentInfo;
						} else {
							console.warn(`Componente "${componentName}": Informazione nel registry non valida (né classe né importer).`);
							continue;
						}

						if (typeof Cmp === 'function') {
							new Cmp(elem, this.contextData);
							$elem.data('g-component-initialized', true);
						} else {
							console.warn(`Componente "${componentName}": Il costruttore finale (Cmp) non è una funzione.`);
						}

					} catch (error) {
						console.error(`Errore durante il caricamento o l'inizializzazione del componente "${componentName}":`, error);
					}
				} else {
					console.warn(`Componente "${componentName}": Non trovato nel registry.`);
				}
			}
		}
	}

	getCssVar(name, elem = document.documentElement) {
		return getComputedStyle(elem).getPropertyValue(name);
	}

	getBreakpoint(bp, elem = document.documentElement) {
		let value = this.getCssVar(`--breakpoint-${bp}`, elem);
		if (value) {
			value = parseInt(value);
		}
		return value || 0;
	}

	defaultContext() {
		$(() => {
			$('.rte table').wrap('<div class="responsive-table" />');
		});
	}
}
